import { ICategory } from '@shared/models/category';
import { Product } from '@shared/models/product';

/** System-Warengruppe laut Seed/Migration (bcm_product_categories.id = 2). */
export const ELECTRIC_METER_PRODUCT_CATEGORY_ID = 2;

/** Legacy-Fallback, falls uniqueId in der DB noch korrekt ist. */
export const ELECTRIC_METER_PRODUCT_CATEGORY_UNIQUE_ID = 'Stromgebühr';

export function isElectricMeterProductCategory(category: ICategory | null | undefined): boolean {
    if (!category) {
        return false;
    }
    if (category.id === ELECTRIC_METER_PRODUCT_CATEGORY_ID) {
        return true;
    }
    return category.uniqueId === ELECTRIC_METER_PRODUCT_CATEGORY_UNIQUE_ID;
}

export function filterElectricMeterProducts(products: Product[]): Product[] {
    return (products || []).filter(product => isElectricMeterProductCategory(product.category));
}

export function findProductById(products: Product[], productId: number | null | undefined): Product | null {
    if (productId == null) {
        return null;
    }
    return products.find(product => product.id === productId) ?? null;
}
